/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_Agent_ChatInputs */

const en_mk_shot_agent_chat = /** @type {(inputs: Mk_Shot_Agent_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A direct conversation with the built-in assistant, its answer streaming in.`)
};

const id_mk_shot_agent_chat = /** @type {(inputs: Mk_Shot_Agent_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percakapan langsung dengan agen bawaan, lengkap dengan jawaban yang mengalir bertahap.`)
};

/**
* | output |
* | --- |
* | "A direct conversation with the built-in assistant, its answer streaming in." |
*
* @param {Mk_Shot_Agent_ChatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_agent_chat = /** @type {((inputs?: Mk_Shot_Agent_ChatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_Agent_ChatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_agent_chat(inputs)
	return en_mk_shot_agent_chat(inputs)
});